import { genericGet } from "../../../services/api.service";
import { EntityConfig } from "../../..";

export const FaturacaoClientesTableConfigs : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
      },
    {
      id: 'code',
      label: 'Fatura',
      type: 'text',
      filterable: true
    },
    
    {
      id: 'client',
      label: 'Cliente',
      type: 'select',
      filterable: true,
      routable: true,
      options: {
        name: 'Cliente',
        route: 'clients',
        value: 'id',
        label: 'name',
        getter: ()=>genericGet('/findByFilter/clientes'),
        searcheable: true
      }
    },
    {
      id: 'date',
      label: 'Data',
      type: 'date',
      filterable: true,
      separateValueUpdateOptions: {
        operation: async (obj: any, state : any)=> {  
          if(!obj['date'] || !state['client'])
            return;
          const client = await genericGet(`/clients/${state['client'].id}`)
          const date = new Date(obj['date'])
          date.setDate(date.getDate() + client.paymentTime);
          const result = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
          console.log("Due date is now: ", result);
          obj['dueDate'] = result;
        },
      }
    },
    {
        id: 'value',
        label: 'Valor',
        type: 'number'
    },
    {
        id: 'dueDate',
        label: 'Data de Vencimento',
        type: 'date',
        filterable: true,

    },
    {
      id: 'receipts',
      label: 'Recibos',
      type: 'multi-select',
      routable: true,
      nonEditable: true,
      options: {
        name: 'Recibos',
        route: 'recibos',
        value: 'id',
        label: 'code',
        searcheable: true
        // triggeredGetter: (i)=>genericGet(`/obras/client/${i}`), // function to trigger according to other form parameter
        // triggerParam: 'client' // Form parameter used to build getterfunction
      }
    },
     {
      id: 'remainingValue',
      label: 'Valor em falta',
      type: 'number',
      nonEditable: true,
      displayInfo: 'currency'

     },
      {
        id: 'obras',
        label: 'Obras',
        type: 'multi-select',
        routable: true,
        options: {
          name: 'Obras',
          route: 'obras',
          value: 'id',
          label: 'number',
          triggeredGetter: (i : number)=>genericGet(`/obras/client/${i}`), // function to trigger according to other form parameter
          triggerParam: 'client', // Form parameter used to build getterfunction
          searcheable: true
        }
      },
    {
      id: 'paid',
      label: 'Pago',
      type: 'boolean',
      filterable: true,

    }
  ];
  